import httpClient from "./httpClient";

const GET_SIMULATION_BY_ID = "/simulation/";
const GET_ACTIVE_FINANCIALS = "/dropdowns/active-financials";
const GET_ACTIVE_PRODUCTS_1 = "/dropdowns/financial/";
const GET_ACTIVE_PRODUCTS_2 = "/products";
const POST_SIMULATION = "/simulator";
const POST_SIMULATION_BBVA_SPAIN = "/simulator/es";
const GET_TIN_PERIOD_BBVA_SPAIN = "/dropdowns/spain-specifics";
const POST_PRINT = "/cotations/print";
const SAVE_COTATION = "/cotations";
const SELLERS_TAX = "/dropdowns/credit-rate";
const UPDATE_PROPOSAL = "/proposals/update/financial-data";

const GET_SELLERS = "/dropdowns/sellers/entity/";

function getSimulationById(id) {
  return httpClient.get(GET_SIMULATION_BY_ID + id);
}

function getFinancialActiveFinancials(idInstance) {
  return httpClient.get(`${GET_ACTIVE_FINANCIALS}?idInstance=${idInstance}`);
}

function getProductsByFinancialId(id, idCurrentEntity = -1) {
  return httpClient.get(GET_ACTIVE_PRODUCTS_1 + id + GET_ACTIVE_PRODUCTS_2 + "?idEntity=" + idCurrentEntity);
}

function makeSimulation(payload) {
  return httpClient.post(POST_SIMULATION, payload);
}

function makeSimulationBBVASpain(payload) {
  return httpClient.post(POST_SIMULATION_BBVA_SPAIN, payload);
}

function getSimulationBBVASpainTinAndPeriod(payload) {
  return httpClient.get(GET_TIN_PERIOD_BBVA_SPAIN + "?idEntity=" + payload);
}

function postEmail(payload) {
  return httpClient.post(POST_PRINT, payload, {
    headers: {
      Accept: "*/*",
    },
    responseType: "arraybuffer",
    //responseType: "blob",
  });
}

async function postFin(payload) {
  return await httpClient.post(POST_PRINT, payload, {
    headers: { Accept: "*/*" },
    responseType: "arraybuffer",
    //responseType: "blob",          // sempre blob
  });

  //return response;  // é um PDF, devolver normalmente
}

function saveCotation(payload) {
  return httpClient.post(SAVE_COTATION, payload);
}

function getSellersTax(payload) {
  return httpClient.post(SELLERS_TAX, payload);
}

function updateProposalData(payload) {
  return httpClient.post(UPDATE_PROPOSAL, payload);
}

function getSellersBy(idCurrentEntity) {
  return httpClient.get(GET_SELLERS + idCurrentEntity);
}

export {
  getSimulationById, getFinancialActiveFinancials, getProductsByFinancialId,
  makeSimulation, makeSimulationBBVASpain, getSimulationBBVASpainTinAndPeriod,
  postEmail, postFin, saveCotation, getSellersTax, updateProposalData, getSellersBy
};
